module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"local":{"label":"Confirm pasword","ruleRepeatPassword":"Please repeat the new password"}},"fr":{"local":{"label":"Confirmation du mot de passe","ruleRepeatPassword":"La confirmation doit être identique au nouveau mot de passe"}}}')
  delete Component.options._Ctor
}
